import TableHeader from "./TableHeader";
import UI from "@mile-meeting/mile-ui";
import TableRow from "./TableRow";
import { TRestrictRequest } from "apis/meetings/block-request";

type Props = {
  data: TRestrictRequest[];
  onClickItem: (item: TRestrictRequest) => void;
  onApproval: (item: TRestrictRequest) => Promise<void>;
  onReject: (item: TRestrictRequest) => void;
};
const PendingRequestTable = ({ data, onClickItem, onApproval, onReject }: Props) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }} className="tableContainer">
      <TableHeader />
      {data.length === 0 && <EmptyRow />}
      {data.length > 0 &&
        data
          .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
          .map((item) => (
            <TableRow
              data={item}
              onClick={() => onClickItem(item)}
              onApproval={async () => await onApproval(item)}
              onReject={() => onReject(item)}
            />
          ))}
    </div>
  );
};

export default PendingRequestTable;

const EmptyRow = () => {
  return (
    <div
      className="empty-row"
      style={{
        display: "flex",
        padding: "12px 24px",
        borderBottom: "1px solid var(--alias-color-line-normal)",
        alignItems: "center",
        gap: 8,
      }}
    >
      <UI.Icon name="removeCircle" size={24} color="var(--alias-color-label-alternative)" />
      <UI.Typography type="body01 normal" fontStyle="regular">
        승인 대기 중인 요청이 없습니다.
      </UI.Typography>
    </div>
  );
};
